<script setup>
import { Head, Link, useForm } from "@inertiajs/inertia-vue3";
import InputText from "primevue/inputtext";
import Button from "primevue/button";
import Checkbox from "primevue/checkbox";

const form = useForm({
    email: "",
    password: "",
    remember: false,
});

const submit = () => {
    form.post(route("login"), {
        onFinish: () => form.reset("password"),
    });
};
</script>
<template>
    <div class="h-screen flex bg-[#FFF053] items-center justify-center">
        <img src="/img/logo-black.png" height="250" width="250" />
        asdasdasda
    </div>
</template>
